
{
  "fr": {
    "read-more": "Lire plus +",
    "read-less": "Lire moins -"
  }
}
